import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { GetMyManagedTeamsUseCase } from '@features/cases';

export const casesHasTeamsGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(GetMyManagedTeamsUseCase)
    .execute()
    .pipe(
      map((teams) => (teams.length > 0 ? true : router.parseUrl('/cases/dashboard'))),
      catchError(() => of(router.parseUrl('/cases/dashboard'))),
    );
};
